jQuery(document).ready(function($) {
var bookingApp = document.querySelector('#booking-app');

if ( bookingApp ) {
  new Vue({
      el: bookingApp,
      data: {
        bookingType     : null,
        headCount       : '',
        shootDayNight   : [],
        shootDates      : '',
        keyInformation  : '',
      },
      filters: {
        numberPeople: function(value) {
          if (!value) return ''
          value = value.toString()
          if ( 1 == value ) {
            return value + ' Person'
          }
          return value + ' People'
        },
        shootDates: function(value) {
          return value
        },
        formatBookingType: function(value) {
          if (!value) return ""
          switch(value) {
            case "TV":
              return 'TV - Episode';
            case "FF":
              return 'Features & Film';
            case "C":
              return 'Commercial';
            case "P":
              return "Print";
            case "":
              return "";
            default:
              return "";
          }
        },
        formatShootDates: function(value) {
          if (!value) return ''
          var dateString = value
          const startDate = formatShootDates(dateString.split(' to ')[0]);
          const endDate   = formatShootDates(dateString.split(' to ')[1]);
          if ( endDate.indexOf("undefined") ) {
            return startDate + ' to ' + endDate;
          }
          return startDate;
        }
      },
      methods: {
        checkShootDayNight: function(e) {
          var checkedItem = e.target;
          var values = [];
          var output = '';

          var shootDayNightCheckboxes = document.getElementsByName("shootDayNight");
          var shootDayNightNa = document.getElementById("id_shootDayNight_na");
          var shootDayNightWrap = document.getElementById("shootDayNightWrap");
        
          // uncheck boxes if n/a selected
          if ( checkedItem.value !== '' ) {
            shootDayNightNa.checked=false;
          } else if ( checkedItem.value == '' ) {
            for (var i=0; i<shootDayNightCheckboxes.length; i++) {
              if ( shootDayNightCheckboxes[i].value !== '' ) {
                shootDayNightCheckboxes[i].checked=false;
              }
            }
          }

          // format values
          for (var i=0; i<shootDayNightCheckboxes.length; i++) {
            if ( shootDayNightCheckboxes[i].checked ) {

              var theValue = shootDayNightCheckboxes[i].value;
              
              if ( theValue == "D") {
                values[i] = "Day";
              }
  
              if ( theValue == "N") {
                values[i] = "Night";
              }
              
            }
          }

          // remove empty values
          var filtered = values.filter(function (el) { 
            return el != null; 
          });
          
          values = filtered;

          // clear text
          if ( values.length == 0 ) {
            output = '';
          }

          // one box checked
          if ( values.length == 1 ) {
            output = values + ' shoot';
          }

          // mor than one box checked
          if ( values.length > 1 ) {
            output = values.join(' and ', values) + ' shoots';
          }

          return shootDayNightWrap.innerHTML = output;

        },
        checkDayType: function(e) {
          var checkedItem = e.target;
          var values = [];
          var output = '';
      
          var dayTypeCheckboxes = document.getElementsByName("dayType");
          var dayTypeNa = document.getElementById("id_dayType_na");
          var dayTypeWrap = document.getElementById("dayTypeWrap");
        
          // uncheck boxes if n/a selected
          if ( checkedItem.value !== '' ) {
            dayTypeNa.checked=false;
          } else if ( checkedItem.value == '' ) {
            for (var i=0; i<dayTypeCheckboxes.length; i++) {
              if ( dayTypeCheckboxes[i].value !== '' ) {
                dayTypeCheckboxes[i].checked=false;
              }
            }
          }
      
          // format values
          for (var i=0; i<dayTypeCheckboxes.length; i++) {
            if ( dayTypeCheckboxes[i].checked ) {
      
              var theValue = dayTypeCheckboxes[i].value;
              if (theValue) {
                values[i] = theValue;
              }
            }
          }

          // remove empty values
          var filtered = values.filter(function (el) { 
            return el != null; 
          });
          
          values = filtered;
      
          // clear text
          if ( values.length == 0 ) {
            output = '';
          }
      
          // one box checked
          if ( values.length == 1 ) {
            output = values + ' day';
          }
      
          // mor than one box checked
          if ( values.length > 1 ) {
            output = values.join(' and ', values) + ' days';
          }
      
          return dayTypeWrap.innerHTML = output;
      
        }
      },
      delimiters: ['[[',']]']
  });
}

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

function formatShootDates(value) {
  const months = [
    'Jan',
    'Feb',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec'
  ]
  const d = new Date(value)
  const monthIndex = d.getUTCMonth()
  const monthName  = months[monthIndex]
  const monthDay   = d.getUTCDate()
  return monthName + ' ' + monthDay
}

    if ( $(".book-date-range-picker").length ) {
        $(".book-date-range-picker").flatpickr({
            mode: 'range',
            minDate: "today",
            maxDate: new Date().fp_incr(365) // 14 days from now
        });
    }

    $("#booking-app [name=shootDayNight], #booking-app input[name=firstName], #booking-app input[name=lastName], #booking-app input[name=email], #booking-app input[name=shootingDates], #booking-app input[name=headCount], #booking-app textarea[name=keyInformation]").on('blur', function() {
        var hasValue       = $(this).val();
        var parentFieldset = $(this).parents('fieldset');
        if (hasValue) {
            parentFieldset.addClass('selected');
        } else {
            parentFieldset.removeClass('selected, error');
        }
    });

    $("#book-wrap input").on('change', function() {
        var parentFieldset = $(this).parent('fieldset');

        parentFieldset.removeClass('selected, error');
        var childChecked = parentFieldset.find('input:checked');
        if (childChecked.length) {
            parentFieldset.addClass('selected');   
        }
    });

});

/* FORM VALIDATION */
// Wait for the DOM to be ready
jQuery(function() {
    // Initialize form validation on the registration form.
    // It has the name attribute "registration"

    if ( $("form[name='book']").length ) {
        validateBookForm();
    }

    function validateBookForm() {

        $("form[name='book']").validate({
        // Specify validation rules
        rules: {
            // The key name on the left side is the name attribute
            // of an input field. Validation rules are defined
            // on the right side
            firstName: "required",
            lastName: "required",
            email: {
              required: true,
              // Specify that email should be validated
              // by the built-in "email" rule
              email: true
            },
            bookingType: "required",
            shootingDates: "required",
            shootDayNight: "required",
            headCount: {
            required: true
            }
        },
        // Specify validation error messages
        messages: {
            firstName: "Please enter your first name",
            lastName: "Please enter your last name",
            headCount: {
              required: "Please provide a head count"
            },
            email: "Please enter a valid email address",
            bookingType: "Please select a booking type",
            shootingDates: "Please select shoot date(s)",
            shootDayNight: "Plese select an option",
        },
        errorPlacement: function(error, element) {
            element.after(error);
            element.parents('fieldset').removeClass('selected').addClass('error');
        },
        // Make sure the form is submitted to the destination defined
        // in the "action" attribute of the form when valid
        submitHandler: function(form) {
            form.submit();
        }
        });
    }

  });